import React from 'react'

import { Form, Col } from '_zari/core'

const TipoConsultaFormGroup = ({ text, value, handleChange }) => {
  return (
    <Form.Group>
      <Col md={12}>
        <Form.Radio
          id={`radio-${text}`}
          name={`radio-${text}`}
          checked={value}
          label={text}
          onClick={handleChange}
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoConsultaFormGroup)
